import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { instantAccessItems } from '../data/instantAccess';
export function InstantAccessSection() {
  return <section aria-labelledby="instant-title" className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-153" data-mp="1mfc73cshcw5p">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-154" data-mp="1hoc53t4i7nwc">
        <p className="mb-4 text-xs font-extrabold uppercase tracking-[0.18em] text-brand-teal" data-id="element-155" data-mp="1hmrak3i6w4yh">ACCESSO IMMEDIATO</p>
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-brand-yellow text-brand-primary" data-id="element-156" data-mp="1wetatoo68zz1">
          <ZapIcon className="h-7 w-7" aria-hidden="true" data-id="element-157" data-mp="25e6j4e0k7ii6" />
        </div>
        <h2 id="instant-title" className="mb-12 text-3xl font-extrabold tracking-tight text-brand-primary md:text-4xl" data-id="element-158" data-mp="20ek7g90dqabh">
          ⚡ Cosa Ottieni Subito?
        </h2>
        <ul className="space-y-3 text-left" data-id="element-159" data-mp="b05jhqx6qrh1">
          {instantAccessItems.map(item => <li key={item} className="flex items-center gap-4 rounded-[18px] border border-brand-sand bg-brand-alt p-5" data-id="element-160" data-mp="623rgghs7htf">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-teal text-white" data-id="element-161" data-mp="2s08g9wk8gedw">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-162" data-mp="2wz2wcqqtfoub" />
              </span>
              <span className="text-sm font-semibold leading-snug md:text-base" data-id="element-163" data-mp="31qtevjzwpiwt">{item}</span>
            </li>)}
        </ul>
        <p className="mt-10 font-display text-2xl font-bold italic text-brand-accent" data-id="element-164" data-mp="35rwr7wiqwwta">
          Non rimarrai mai più senza materiale.
        </p>
      </Reveal>
    </section>;
}